module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAXElEQVQ4jWP8////fwYKABMlmhkYGBhYGBgYGDZv3kyWZl9fX4gBMA4pAGYpxV6gThj4PdnDwDB9D8ma/zP4DgIvMP7/////dXVhsjRr3nw7CLxAnTAYUBdQbAAATXgZpVYfzF0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BG.png
// module id = 1089
// module chunks = 0